import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import toast from 'react-hot-toast'
import { FaCheckDouble } from 'react-icons/fa6'
import { fetchData } from '../../../helpers/fetchData'
import CustomButton from '../../../shared/CustomButton'
import DatePicker from '../../../shared/DatePicker'

function PolicyHolderFixModal({ filters, onClose, onComplete }) {
  const { t } = useTranslation()
  const [formData, setFormData] = useState({
    start_date: filters?.start_date || moment().format('YYYY-MM-DD'),
    end_date: filters?.end_date || moment().format('YYYY-MM-DD')
  })
  const [loading, setLoading] = useState(false)

  const handleDateChange = event => {
    const { name, value } = event.target || {}
    setFormData(prev => ({
      ...prev,
      [name]: value ? moment(value).format('YYYY-MM-DD') : ''
    }))
  }

  const handleSubmit = async () => {
    if (!formData.start_date || !formData.end_date) {
      toast.error(t('Please select both start and end dates'))
      return
    }

    if (moment(formData.start_date).isAfter(moment(formData.end_date))) {
      toast.error(t('Start date must be before end date'))
      return
    }

    setLoading(true)
    try {
      const response = await fetchData('POST', '/v3/invoices/policyHolderFixJob', formData)
      if (response?.job_id) {
        toast.success(t('Policy holder fix job started'))
        onComplete?.()
        onClose?.()
      }
    } catch (error) {
      toast.error(error?.message || t('Failed to start policy holder fix job'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='space-y-4'>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
        <DatePicker
          label={t('Visit Start Date')}
          name='start_date'
          value={formData.start_date ? moment(formData.start_date, 'YYYY-MM-DD').toDate() : null}
          onChange={handleDateChange}
          useFormik={false}
          placeholder={t('Visit Start Date')}
          dateFormat='dd/mm/yy'
        />
        <DatePicker
          label={t('Visit End Date')}
          name='end_date'
          value={formData.end_date ? moment(formData.end_date, 'YYYY-MM-DD').toDate() : null}
          onChange={handleDateChange}
          useFormik={false}
          placeholder={t('Visit End Date')}
          dateFormat='dd/mm/yy'
        />
      </div>

      <div className='flex justify-end gap-2 pt-2'>
        <CustomButton
          label={t('Close')}
          buttonType='reset'
          onClick={onClose}
          disabled={loading}
        />
        <CustomButton
          label={t('Start Update')}
          buttonType='success'
          onClick={handleSubmit}
          loading={loading}
          disabled={loading}
          icon={<FaCheckDouble size={15} className='me-2' />}
        />
      </div>
    </div>
  )
}

export default PolicyHolderFixModal
